module.exports = __webpack_public_path__ + "img/feature-6.91d0e72b.png";